module.exports = __webpack_public_path__ + "img/action.7c282fd4.png";